import { render } from "./MerchantReceiptForwardModal.vue?vue&type=template&id=c3b43584&ts=true"
import script from "./MerchantReceiptForwardModal.vue?vue&type=script&lang=ts"
export * from "./MerchantReceiptForwardModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__